/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aml_Val_Items_RequiredInputs */

const vi_aml_val_items_required = /** @type {(inputs: Aml_Val_Items_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phiếu phải có ít nhất 1 dòng`)
};

/**

* @param {Aml_Val_Items_RequiredInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const aml_val_items_required = /** @type {((inputs?: Aml_Val_Items_RequiredInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aml_Val_Items_RequiredInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_aml_val_items_required(inputs)
});